import { all } from "redux-saga/effects";
import { watchFetchUser, watchLogout } from "./services/common/auth/sagas";
import { watchFetchApplications } from "./services/common/applications/sagas";
import {
    watchFetchInvitations,
    watchReplyInvitation,
    watchSendInvitation,
    watchUpdateInvitation,
} from "./services/common/invitations/sagas";
import {
    watchFetchMembers,
    watchUpdateMembership,
} from "./services/common/membership/sagas";
import {
    watchCreatePortalSession,
    watchCreateSubscription,
    watchFetchSubscriptions,
    watchUpgradeSubscription,
} from "./services/common/subscription/sagas";
import {
    watchAddWorkspace,
    watchDeleteWorkspace,
    watchFetchWorkspaces,
    watchGetSingleWorkspace,
    watchUpdateWorkspace,
    watchfetchWorkspacePermissions,
    watchFetchApiKey,
} from "./services/common/workspace/sagas";

export default function* rootSaga() {
    yield all([
        watchLogout(),
        watchFetchUser(),
        watchAddWorkspace(),
        watchFetchWorkspaces(),
        watchGetSingleWorkspace(),
        watchUpdateWorkspace(),
        watchDeleteWorkspace(),
        watchFetchApiKey(),
        watchFetchApplications(),
        watchCreateSubscription(),
        watchUpgradeSubscription(),
        watchFetchSubscriptions(),
        watchCreatePortalSession(),
        watchFetchMembers(),
        watchUpdateMembership(),
        watchFetchInvitations(),
        watchSendInvitation(),
        watchReplyInvitation(),
        watchUpdateInvitation(),
        watchfetchWorkspacePermissions(),
    ]);
}
